module.exports = __webpack_public_path__ + "static/media/Muk_gaussian2.61731194.png";